import { inject, observer } from "mobx-react";
import * as React from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { Form, Grid, Segment, Header, List, Statistic, Card, Icon, Label, Button } from "semantic-ui-react";
import { IAppModel } from "../../../AppModel";
import { IErrorModel } from "../../../components/common/error/ErrorModel";
import { ReportCardSummary } from "../../report/components";
import { FiscalYearDDL } from "../../../components/project/year";
import ProvinceDDL from "../../../components/address/ProvinceDDL";
import { LocationModel } from "../../../components/address";
import { fetchNoService } from "../../../utils/request-noservice";
import { DonationDocUrl } from "../../donation/DonationService";
import { IPublicDebtReportModel, PublicDebtReportModel } from "../AccountReceivableModel";
import { currency } from "../../../utils/format-helper";
import { data } from "jquery";
import { DateInput } from "../../../components/common";


interface IDashboardData
  extends WithTranslation,
  RouteComponentProps {
  errorObject: IErrorModel;
  appStore?: IAppModel;
  publicDebtReport: IPublicDebtReportModel;
}

@inject("appStore")
@observer
class DashboardData extends React.Component<IDashboardData> {
  public state = {
    fiscalYearStart: "",
    fiscalYearEnd: "",
    region: "",
    province: "",
    startMonth: "",
    endMonth: "",
  };
  public componentDidMount() {
    // this.setState({fiscalYearStart: "", fiscalYearEnd: ""});
  }
  public locationStore = LocationModel.create({});

  public render() {
    const { t, publicDebtReport, appStore } = this.props;
    return (
      <Grid id={"publicDebtReport"}>
        <Grid.Row columns={1}>
          <Grid.Column>
            <ReportCardSummary
              title={t("")}
              filter={
                <Grid columns={"equal"} doubling stackable>
                  <Grid.Row>
                    <Grid.Column>
                      <Form.Field
                        required
                        label={t("module.report.public.fiscalYearStart")}
                        control={FiscalYearDDL}
                        placeholder={t("module.report.public.pleaseSelectFiscalYearStart")}
                        value={this.state.fiscalYearStart}
                        onChange={this.onSelectedFiscalYearStart}
                      />
                    </Grid.Column>
                    <Grid.Column>
                      <Form.Field
                        required
                        label={t("module.report.public.fiscalYearEnd")}
                        control={FiscalYearDDL}
                        placeholder={t("module.report.public.pleaseSelectFiscalYearEnd")}
                        value={this.state.fiscalYearEnd}
                        onChange={this.onSelectedFiscalYearEnd}
                      />
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column>
                      <Form.Field
                        label={t("module.report.DateFilterDDL.startMonth")}
                        control={DateInput}
                        type="month"
                        formatdate="MMMM"
                        value={this.state.startMonth}
                        fieldName={"yearMonth"}
                        onChangeInputField={this.onSelectedStartMonth}
                        id={"dashboard-start-month"}
                      />
                    </Grid.Column>
                    <Grid.Column>
                      <Form.Field
                        label={t("module.report.DateFilterDDL.endMonth")}
                        control={DateInput}
                        type="month"
                        formatdate="MMMM"
                        value={this.state.endMonth}
                        fieldName={"yearMonth"}
                        onChangeInputField={this.onSelectedEndMonth}
                        id={"dashboard-end-month"}
                      />
                    </Grid.Column>
                    <Grid.Column width={5}>
                      <Form.Input
                        // disabled={this.state.disProvinceAndOrg}
                        label={t("module.report.public.province")}
                        placeholder={t("module.report.public.pleaseSpecifyProvince")}
                        control={ProvinceDDL}
                        locationStore={this.locationStore}
                        selectedValue={this.state.province}
                        onChange={this.onSelectedProvince}
                      />
                    </Grid.Column>
                    <Grid.Column width={5}>
                      <Form.Select
                        clearable
                        options={appStore!.enumItems("region")}
                        label={t("module.report.public.region")}
                        placeholder={t("module.report.public.pleaseSpecifyRegion")}
                        fluid
                        value={this.state.region}
                        onChange={this.onSelectedRegion}
                      />
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              }
              onGetReport={this.onGetReport}
            />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row columns={1}>
          <Grid.Column>
            <Segment>
              <div>
                <Header as='h2' attached='top' color="blue">
                  ลูกหนี้ที่ทำสัญญาทั้งหมดของกองทุนผู้สูงอายุ ตั้งแต่ปีงบประมาณ {this.state.fiscalYearStart} ถึง {this.state.fiscalYearEnd}
                </Header>
                <Segment attached textAlign="center">
                  <Card.Group textAlign="center">
                    <Card color="blue">
                      <Card.Content header='จำนวน (ราย)' textAlign="center" />
                      <Card.Content textAlign="center" header=''>
                        <Card.Header>{currency(publicDebtReport.ar_all.the_count, 0)}</Card.Header>
                      </Card.Content>
                    </Card >

                    <Card color="blue">
                      <Card.Content header='เป็นเงิน (บาท)' textAlign="center" />
                      <Card.Content textAlign="center" header=''>
                        <Card.Header>{currency(publicDebtReport.ar_all.the_sum_outstanding, 2)}</Card.Header>
                      </Card.Content>
                    </Card>
                  </Card.Group>
                </Segment>

              </div>
            </Segment>
          </Grid.Column>
        </Grid.Row>

        <Grid.Row columns={3}>
          <Grid.Column>
            <Segment>
              <div>
                <Header as='h3' attached='top' color="red">
                  ปิดบัญชีแล้ว
                </Header>
                <Segment attached textAlign="center">
                  <Card.Group textAlign="center">
                    <Card color="red">
                      <Card.Content header='จำนวน (ราย)' textAlign="center" />
                      <Card.Content textAlign="center" header=''>
                        <Card.Header>{currency(publicDebtReport.ar_close.the_count, 0)}</Card.Header>
                      </Card.Content>
                    </Card>

                    <Card color="red">
                      <Card.Content header='เป็นเงิน (บาท)' textAlign="center" />
                      <Card.Content textAlign="center" header=''>
                        <Card.Header>{currency(publicDebtReport.ar_close.the_sum_loan_mount, 2)}</Card.Header>
                      </Card.Content>
                    </Card>
                  </Card.Group>
                </Segment>
              </div>
            </Segment>
          </Grid.Column>

          <Grid.Column>
            <Segment>
              <div>
                <Header as='h3' attached='top' color="green">
                  ลูกหนี้ชำระปกติ
                </Header>
                <Segment attached textAlign="center">
                  <Card.Group textAlign="center">
                    <Card color="green">
                      <Card.Content header='จำนวน (ราย)' textAlign="center" />
                      <Card.Content textAlign="center" header=''>
                        <Card.Header>{currency(publicDebtReport.ar_pay_normal.the_count, 0)}</Card.Header>
                      </Card.Content>
                    </Card>

                    <Card color="green">
                      <Card.Content header='เป็นเงิน (บาท)' textAlign="center" />
                      <Card.Content textAlign="center" header=''>
                        <Card.Header>{currency(publicDebtReport.ar_pay_normal.the_sum_loan_mount, 2)}</Card.Header>
                      </Card.Content>
                    </Card>
                  </Card.Group>
                </Segment>
              </div>
            </Segment>
          </Grid.Column>

          <Grid.Column>
            <Segment>
              <div>
                <Header as='h3' attached='top' color="orange">
                  ลูกหนี้ที่ยังไม่ถึงกำหนดชำระ
                </Header>
                <Segment attached textAlign="center">
                  <Card.Group textAlign="center">
                    <Card color="orange">
                      <Card.Content header='จำนวน (ราย)' textAlign="center" />
                      <Card.Content textAlign="center" header=''>
                        <Card.Header>{currency(publicDebtReport.ar_not_dea.the_count, 0)}</Card.Header>
                      </Card.Content>
                    </Card>

                    <Card color="orange">
                      <Card.Content header='เป็นเงิน (บาท)' textAlign="center" />
                      <Card.Content textAlign="center" header=''>
                        <Card.Header>{currency(publicDebtReport.ar_not_dea.the_sum_loan_mount, 2)}</Card.Header>
                      </Card.Content>
                    </Card>
                  </Card.Group>
                </Segment>
              </div>
            </Segment>
          </Grid.Column>

        </Grid.Row>
        <Grid.Row columns={3}>

          <Grid.Column>
            <Segment>
              <div>
                <Header as='h3' attached='top' color="red">
                  ลูกหนี้ที่ที่ถึงกำหนดชำระ
                </Header>
                <Segment attached textAlign="center">
                  <Card.Group textAlign="center">
                    <Card color="red">
                      <Card.Content header='จำนวน (ราย)' textAlign="center" />
                      <Card.Content textAlign="center" header=''>
                        <Card.Header>{currency(publicDebtReport.ar_pay_dea.the_count, 0)}</Card.Header>
                      </Card.Content>
                    </Card>

                    <Card color="red">
                      <Card.Content header='เป็นเงิน (บาท)' textAlign="center" />
                      <Card.Content textAlign="center" header=''>
                        <Card.Header>{currency(publicDebtReport.ar_pay_dea.the_sum_loan_mount, 2)}</Card.Header>
                      </Card.Content>
                    </Card>
                  </Card.Group>
                </Segment>
              </div>
            </Segment>
          </Grid.Column>

          <Grid.Column >
            <Segment >
              <div>
                <Header as='h3' attached='top' color="violet">
                  ลูกหนี้ที่ชำระตั้งแต่2 งวดขึ้นไป
                </Header>
                <Segment attached textAlign="center">
                  <Card.Group textAlign="center" >
                    <Card color="violet">
                      <Card.Content header='จำนวน (ราย)' textAlign="center" />
                      <Card.Content textAlign="center" header=''>
                        <Card.Header>{currency(publicDebtReport.ar_pay_two.the_count, 0)}</Card.Header>
                      </Card.Content>
                    </Card>

                    <Card color="violet">
                      <Card.Content header='เป็นเงิน (บาท)' textAlign="center" />
                      <Card.Content textAlign="center" header=''>
                        <Card.Header>{currency(publicDebtReport.ar_pay_two.the_sum_loan_mount, 2)}</Card.Header>
                      </Card.Content>
                    </Card>
                  </Card.Group>
                </Segment>
              </div>
            </Segment>
          </Grid.Column>

          <Grid.Column>
            <Segment>
              <div>
                <Header as='h3' attached='top' color="red">
                  ลูกหนี้ที่ไม่ชำระคืนเลย
                </Header>
                <Segment attached textAlign="center">
                  <Card.Group textAlign="center">
                    <Card color="red">
                      <Card.Content header='จำนวน (ราย)' textAlign="center" />
                      <Card.Content textAlign="center" header=''>
                        <Card.Header>{currency(publicDebtReport.ar_not_pay.the_count, 0)}</Card.Header>
                      </Card.Content>
                    </Card>

                    <Card color="red">
                      <Card.Content header='เป็นเงิน (บาท)' textAlign="center" />
                      <Card.Content textAlign="center" header=''>
                        <Card.Header>{currency(publicDebtReport.ar_not_pay.the_sum_loan_mount, 2)}</Card.Header>
                      </Card.Content>
                    </Card>

                    {/* <Card color="red">
                      <Card.Content header='โดยแบ่งเป็น' textAlign="center" />
                      <Card.Content textAlign="center">
                        -ลูกหนี้ที่ครบกำหนดสัญญา จำนวน 870 ราย  เป็นเงิน 23,528,890 บาท
                      </Card.Content>
                      <Card.Content textAlign="center">
                        -ลูกหนี้ที่อยู่ในกำหนดสัญญา จำนวน 831 ราย  เป็นเงิน 23,660,010 บาท
                      </Card.Content>
                    </Card> */}
                  </Card.Group>

                </Segment>
              </div>
            </Segment>
          </Grid.Column>


        </Grid.Row>
        <Grid.Row columns={3}>

          <Grid.Column>
            <Segment>
              <div>
                <Header as='h3' attached='top' color="orange">
                  ลูกหนี้คงเหลือตามสัญญา
                </Header>
                <Segment attached textAlign="center">
                  <Card.Group textAlign="center">
                    <Card color="orange">
                      <Card.Content textAlign="center" header=''>
                        <Card.Header>รายบุคคล จำนวน  {currency(publicDebtReport.ar_normal_personal.the_count, 0)} ราย</Card.Header>
                      </Card.Content>
                      <Card.Content textAlign="center">
                        <Card.Header>วงเงินที่ปล่อยกู้  {currency(publicDebtReport.ar_normal_personal.the_sum_loan_mount, 2)} บาท</Card.Header>
                      </Card.Content>
                      <Card.Content textAlign="center">
                        <Card.Header>ยอดหนี้้คงเหลือ  {currency(publicDebtReport.ar_normal_personal.the_sum_outstanding, 2)} บาท</Card.Header>
                      </Card.Content>
                    </Card>
                  </Card.Group>

                  <Card.Group textAlign="center">
                    <Card color="orange">
                      <Card.Content textAlign="center" header=''>
                        <Card.Header>รายกลุ่ม จำนวน  {currency(publicDebtReport.ar_normal_group.the_count, 0)} กลุ่ม</Card.Header>
                      </Card.Content>
                      <Card.Content textAlign="center">
                        <Card.Header>วงเงินที่ปล่อยกู้ {currency(publicDebtReport.ar_normal_group.the_sum_loan_mount, 2)} บาท</Card.Header>
                      </Card.Content>
                      <Card.Content textAlign="center">
                        <Card.Header>ยอดหนี้้คงเหลือ {currency(publicDebtReport.ar_normal_group.the_sum_outstanding, 2)} บาท</Card.Header>
                      </Card.Content>
                    </Card>
                  </Card.Group>
                </Segment>
              </div>
            </Segment>
          </Grid.Column>

          {/* <Grid.Column>
            <Segment>
              <div>
                <Header as='h3' attached='top' color="violet">
                  ได้รับชำระคืนตั้งแต่ปี {this.state.fiscalYearStart} ถึง {this.state.fiscalYearEnd} รวมปิดบัญชีแล้ว
                </Header>
                <Segment attached textAlign="center">
                  <Card.Group textAlign="center">
                    <Card color="violet">
                      <Card.Content textAlign="center" header=''>
                        <Card.Header>จำนวน {"226,211"} ราย</Card.Header>
                      </Card.Content>
                      <Card.Content textAlign="center" header=''>
                        <Card.Header>วงเงินที่ปล่อยกู้ {"226,211.00"} บาท</Card.Header>
                      </Card.Content>
                      <Card.Content textAlign="center" header=''>
                        <Card.Header>ยอดเงินที่ได้รับชำระทั้งหมด {"226,211.00"} บาท</Card.Header>
                      </Card.Content>
                    </Card>
                  </Card.Group>

                  <Card.Group textAlign="center">
                    <Card color="violet">
                      <Card.Content textAlign="center" header=''>
                        <Card.Header>รายกลุ่ม จำนวน {"226,211"} กลุ่ม</Card.Header>
                      </Card.Content>
                      <Card.Content textAlign="center" header=''>
                        <Card.Header>วงเงินที่ปล่อยกู้ {"226,211.00"} บาท</Card.Header>
                      </Card.Content>
                      <Card.Content textAlign="center" header=''>
                        <Card.Header>ยอดเงินที่ได้รับชำระทั้งหมด {"226,211.00"} บาท</Card.Header>
                      </Card.Content>
                    </Card>
                  </Card.Group>
                </Segment>
              </div>
            </Segment>
          </Grid.Column> */}



          {/* <Grid.Column>
            <Segment>
              <div>
                <Header as='h3' attached='top' color="violet">
                  การตัดจำหน่ายหนี้สูญของกองทุนผู้สูงอายุ
                </Header>
               
                <Segment attached textAlign="center">
                  <Card.Group>
                    <Card color='violet'>
                      <Card.Content textAlign="center" header=''>
                        <Card.Header>ส่วนกลาง</Card.Header>
                      </Card.Content>
                      <Card.Content textAlign="center" header=''>
                        <Card.Header>กรุงเทพมหานคร จำนวน {"226,211.00"} บาท</Card.Header>
                      </Card.Content>
                      <Card.Content textAlign="center" header=''>
                        <Card.Header>เป็นเงิน {"226,211.00"} บาท</Card.Header>
                      </Card.Content>
                    </Card>
                  </Card.Group>

                  <Card.Group textAlign="center">
                    <Card color='violet'>
                      <Card.Content textAlign="center" header='' color="red">
                        <Card.Header>ส่วนภูมิภาค</Card.Header>
                      </Card.Content>
                      <Card.Content textAlign="center" header=''>
                        <Card.Header>จังหวัดพิจิตร จำนวน {"226,211.00"} บาท</Card.Header>
                      </Card.Content>
                      <Card.Content textAlign="center" header=''>
                        <Card.Header>เป็นเงิน {"226,211.00"} บาท</Card.Header>
                      </Card.Content>
                    </Card>
                  </Card.Group>
                </Segment>
              </div>
            </Segment>
          </Grid.Column> */}
        </Grid.Row>
      </Grid>
    );
  }

  private onSelectedRegion = (event: any, data: any) => {
    this.setState({ region: data.value });
  };

  private onSelectedStartMonth = (fieldName: string, value: any) => {
    const date = new Date(value);
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    this.setState({ startMonth: `${month}` });
  };

  private onSelectedEndMonth = (fieldName: string, value: any) => {
    const date = new Date(value);
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    this.setState({ endMonth: `${month}` });
  };

  private onSelectedFiscalYearStart = (value: any) => {
    this.setState({ fiscalYearStart: value });
  };
  private onSelectedFiscalYearEnd = (value: any) => {
    this.setState({ fiscalYearEnd: value });
  };

  private onSelectedProvince = (value: any) => {
    this.setState({ province: value });
  };

  private onGetReport = async () => {
    const { errorObject, publicDebtReport } = this.props;
    try {
      if (this.state.fiscalYearStart != "" && this.state.fiscalYearEnd != "") {
        await publicDebtReport.getPublicDebtReports(
          this.state.fiscalYearStart,
          this.state.fiscalYearEnd,
          this.state.province,
          this.state.region,
          this.state.startMonth,
          this.state.endMonth
        );

      } else {
        errorObject.setField({ fieldname: "tigger", value: true });
        errorObject.setField({ fieldname: "title", value: "กรอกข้อมูลให้ครบถ้วน" });
        errorObject.setField({ fieldname: "message", value: "โปรดเลือกปีเริ่มต้น-สิ้นสุด" });
      }

    } catch (e) {
      errorObject.setField({ fieldname: "tigger", value: true });
      errorObject.setField({ fieldname: "code", value: e.code });
      errorObject.setField({ fieldname: "title", value: e.name });
      errorObject.setField({ fieldname: "message", value: e.message });
      errorObject.setField({
        fieldname: "technical_stack",
        value: e.technical_stack,
      });
    }
  };
}

export default withRouter(withTranslation()(DashboardData));
